import $ from 'jquery';
import 'autoresize-textarea';

export const textareaAutoResize = {

  init: function (element) {
    $(element).autoResize();
  }
};